/* Publish by EComposer at 2026-10-30 15:03:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pnts4quj85q"]=  window.__ectimmers["ecom-pnts4quj85q"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-pnts4quj85q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnts4quj85q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hoxv99dzd9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hoxv99dzd9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6vuztwujmlb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6vuztwujmlb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cx4kb9lt74').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cx4kb9lt74', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9adyv9aez9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9adyv9aez9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-du7py4cdw55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-du7py4cdw55', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vm0q3p722jj"]=  window.__ectimmers["ecom-vm0q3p722jj"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-vm0q3p722jj"]["dyot7da5a"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-vm0q3p722jj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vm0q3p722jj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67lcxuxevzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67lcxuxevzu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjs7u7v3yb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjs7u7v3yb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wdnipxahbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wdnipxahbx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xh1eieiat9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xh1eieiat9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u48jm0tsk88').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u48jm0tsk88', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9dci6ahgohb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9dci6ahgohb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g25dx7wmt0l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g25dx7wmt0l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}